import { render, staticRenderFns } from "./StrategyModal.vue?vue&type=template&id=19965809&"
import script from "./StrategyModal.vue?vue&type=script&lang=js&"
export * from "./StrategyModal.vue?vue&type=script&lang=js&"
import style0 from "./StrategyModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports